import { render, staticRenderFns } from "./RsaPazienteImpegnativaPage.vue?vue&type=template&id=6f1f957b"
import script from "./RsaPazienteImpegnativaPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteImpegnativaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports